import styled from 'styled-components';
import DefaultContainer from './DefaultContainer';

export default styled(DefaultContainer)`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.gradient[0]};

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 0px 1%;
    margin-bottom: 150px;
  }

  > .center {
    margin-top: 120px;
    border-radius: 20px;
    border: 1px solid ${({ theme }) => theme.colors.primary.main};
    background-color: ${({ theme }) => theme.colors.grey.black};
    padding: 60px 3% 60px 3%;
    gap: 32px;

    @media ${({ theme }) => theme.devices.mobile} {
      padding: 20px 3%;
      gap: 16px;
    }
  }
`;
